import { createMotionProxy } from '../create-proxy.mjs';

const m = /*@__PURE__*/ createMotionProxy();

export { m };
